import React from 'react';
import { propertyCriteria } from '../../constants/propertyCriteria';

interface PropertyCriteriaSelectorProps {
  propertyType: string;
  selectedCriteria: Record<string, boolean>;
  onChange: (criteriaId: string, value: boolean) => void;
}

export const PropertyCriteriaSelector: React.FC<PropertyCriteriaSelectorProps> = ({
  propertyType,
  selectedCriteria,
  onChange,
}) => {
  console.log('🎯 PropertyCriteriaSelector render:', { propertyType, selectedCriteria });
  
  // Mapper les types de biens du formulaire vers les clés du propertyCriteria
  const typeMapping: Record<string, keyof typeof propertyCriteria> = {
    'Appartement': 'apartment',
    'Maison': 'house', 
    'Promotion': 'promotion',
    'Terrain': 'land',
    'Commerce': 'commercial'
  };
  
  const mappedType = typeMapping[propertyType];
  const criteria = mappedType ? propertyCriteria[mappedType] : [];
  
  console.log('🎯 Type mappé:', mappedType, 'Critères disponibles:', criteria.length);

  if (!propertyType || criteria.length === 0) {
    return (
      <p className="text-gray-500 dark:text-gray-400">
        {!propertyType ? 'Veuillez d\'abord sélectionner un type de bien' : 'Aucun critère disponible pour ce type de bien'}
      </p>
    );
  }

  return (
    <div className="grid grid-cols-2 gap-4">
      {criteria.map(({ id, label }) => (
        <label key={id} className="flex items-center gap-2">
          <input
            type="checkbox"
            checked={selectedCriteria[id] || false}
            onChange={(e) => {
              console.log('📋 Checkbox changé:', id, e.target.checked);
              onChange(id, e.target.checked);
            }}
            className="h-4 w-4 rounded border-gray-300 text-primary-500 focus:ring-primary-500"
          />
          <span className="text-sm text-gray-700 dark:text-gray-200">
            {label}
          </span>
        </label>
      ))}
    </div>
  );
};